export default {
  'RDSTATION' (state) {
    return state.rdstation
  }
}
